import React, { useEffect, useState } from 'react';
import { SessionState, isClient } from '../../../reducers/auth/session';
import { Stack } from '@mui/material';
//import { Box, Paper, Typography } from '@mui/material';
import { AppState } from '../../../reducers/index';
import { connect, useDispatch } from 'react-redux';
import OrderList from '../Orders/OrdersList';
import NotificationList from '../Notifications/NotificationsList';
import InvoiceList from '../Invoices/InvoicesList';
import ComplaintList from '../Complaints/ComplaintsList';
import PrepaymentList from '../Prepayments/PrepaymentsList';
import { InvoiceListState } from '../../../reducers/invoice/invoiceList';
import { OrderListState } from '../../../reducers/order/orderList';
import { NotificationListState } from '../../../reducers/notification/notificationList';

// import { Analytics, AttachMoney } from '@mui/icons-material';
//import { Avatar } from '@mui/material';
//import { useThemeContext } from '../../../theme/ThemeContext';
//import { formattedNumber } from '../../../utils/StringUtils';
//import { useTranslation } from 'react-i18next';
//import { fetchOrderTotalInterval } from '../../../actions/order/orderTotalInterval';
//import moment from 'moment'
import { ComplaintListState } from '../../../reducers/complaint/complaintList';
import { fetchPrepaymentCount } from '../../../actions/prepayment/prepaymentCount';
import { PrepaymentDetailState } from '../../../reducers/prepayment/prepaymentDetail';
import { InvoiceAzureState } from '../../../reducers/invoice/invoicesAzure';
import { PreorderListState } from '../../../reducers/preorder/preorderList';
import { PreorderDataState } from '../../../reducers/preorder/preorderData';
import { fetchPendingPreorder } from '../../../actions/preorder/preorder';
import { fetchPreorders } from '../../../actions/preorder/preorderList';
import { GeneralDescState } from '../../../reducers/generalDescList';
import { fetchGeneralDesc } from '../../../actions/generalDesc';
import { BouncedReceiptListState } from '../../../reducers/bouncedReceipt/bouncedReceiptList';

interface Props {
  session: SessionState,
  invoiceList: InvoiceListState,
  bouncedReceiptList: BouncedReceiptListState,
  invoiceAzure: InvoiceAzureState,
  orderList: OrderListState,
  complaintList: ComplaintListState,
  prepaymentList: PrepaymentDetailState,
  preorderList: PreorderListState,
  preorder: PreorderDataState,
  generalDescList: GeneralDescState,
  notificationList: NotificationListState
}

const Dashboard: React.FC<Props> = ({ session, invoiceList, bouncedReceiptList, invoiceAzure, orderList, complaintList, notificationList, prepaymentList, preorderList, preorder, generalDescList }) => {
  //const { theme } = useThemeContext()
  const dispatch = useDispatch()
  
  //const [average, setAverage] = useState<number>(0)
  //const [averagePrevious, setAveragePrevious] = useState<number>(0)
  //const [totalCurrent, setTotalCurrent] = useState<number>(0)
  //const [totalPrevious, setTotalPrevious] = useState<number>(0)
  const [prepaymentCount, setPrepaymentCount] = useState<number>(0)
  

  //const getAveragePreviousMonths = () => getDataCards(6, 4, (total: number) => setAveragePrevious(total / 3))
  //const getAverageLastMonths = () => getDataCards(3, 1, (total: number) => setAverage(total / 3))

  //const getTotalPreviousMonth = () => getDataCards(1, 1, (total: number) => setTotalPrevious(total))
  //const getTotalCurrentMonth = () => getDataCards(0, 0, (total: number) => setTotalCurrent(total))

  /*  const getDataCards = (from: number, to: number, handleResponse: (total: number) => void) => {
      if (isClient(session)) {
        dispatch(fetchOrderTotalInterval(session.byPersonTypeId ? session.byPersonTypeId?.toString() : '',
          moment().subtract(from, 'month').startOf('month').tz("America/Argentina/Buenos_Aires").format(), moment().subtract(to, 'month').endOf('month').tz("America/Argentina/Buenos_Aires").format(), handleResponse))
      }
    }
  */

  const getPrepaymentCount = () => {
    if (isClient(session)) {
      dispatch(fetchPrepaymentCount(session.byPersonTypeId ? session.byPersonTypeId?.toString() : '', (count: number) => setPrepaymentCount(count)))
    }
  }

  useEffect(() => {
    dispatch({ type: 'ORDER_CLEAR' })
    //getAveragePreviousMonths()
    //getAverageLastMonths()
    //getTotalPreviousMonth()
    //getTotalCurrentMonth()
    getPrepaymentCount()
    dispatch(fetchPendingPreorder())
    dispatch(fetchPreorders())
    dispatch(fetchGeneralDesc('?type=cpt'))
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [])


  /*
  interface ISCardProps {
    title: string,
    money: string,
    value: number,
    variant: number,
    icon: React.ReactNode,
    footer: string
  }

  const ISCard: React.FC<ISCardProps> = (props: ISCardProps) => {

    return (
      <Paper elevation={2}
        style={{
          padding: "5px 15px 8px 15px", display: "flex", flexDirection: "column",
          textAlign: "justify", justifyContent: "space-around",
          width: "330px", minWidth: "280px", minHeight: "150px",
          borderRadius: "4px", margin: "5px"
        }}>
        <Typography fontWeight="bold" variant="caption">{props.title}</Typography>
        <Box display="flex" justifyContent="space-evenly" alignItems="center">
          <Box display="flex" justifyContent="space-evenly" alignItems="center">
            <Typography variant="h4">{`${props.money}${formattedNumber(Number(Number(props.value / 1000).toFixed(0)))}k`}&nbsp;</Typography>
            <Typography fontWeight="medium" color={props.variant < 0 ? theme.palette.error.main : theme.palette.success.main}
              variant="caption">{props.variant < 0 ? "-" : "+"}{`${props.money}${formattedNumber(Number(Number(Math.abs(props.variant / 1000)).toFixed(0)))}k`}</Typography>
          </Box>
          <Avatar sx={{ width: 48, height: 48, color: theme.palette.success.light, backgroundColor: theme.palette.action.selected }}>
            {props.icon}
          </Avatar>
        </Box>
        <Typography fontSize={10}>{props.footer}</Typography>
      </Paper>
    )
  }
  */

  return (
    <Stack display="flex" flexDirection="column" flexWrap="wrap" alignContent="stretch">
      {/* - solicitado 25-9 quitar 
      <Stack style={{ margin: "10px" }} display="flex" flexDirection="row" justifyContent="space-around">
        <ISCard title={t('card1.title')} money={t('card1.money')}
          value={totalCurrent}
          variant={+(+totalCurrent - +totalPrevious)}
          icon={<LocalOffer />} footer={t('card1.footer')} />
        <ISCard title={t('card2.title')} money={t('card2.money')} value={average}
          variant={+(+average - +averagePrevious)}
          icon={<Inventory />} footer={t('card2.footer')} />
        / * <Stack style={{margin:"10px"}} display="flex" flexDirection="row" justifyContent="space-between">
            <ISCard title={t('card3.title')} money={t('card3.money')} value='20k' variant={2700} icon={<Analytics/>} footer={t('card3.footer')}/>
          <ISCard title={t('card4.title')} money={t('card4.money')} value='25k' variant={5000} icon={<AttachMoney style={{width: 30, height: 30}}/>} footer={t('card4.footer')}/> * /
      </Stack> */}
      {/*
      <Stack style={{ margin: "10px" }}>
        <InvoiceList fullInfo={false} session={session} invoiceList={invoiceList} />
      </Stack>
        */}

      <Stack style={{ margin: "10px" }} display="flex" flexDirection="row" justifyContent="space-between">
        {prepaymentCount > 0 ?
          <PrepaymentList fullInfo={false} session={session} prepaymentList={prepaymentList} preorder={preorder} preorderList={preorderList} /> :
          <InvoiceList fullInfo={false} session={session} invoiceList={invoiceList} bouncedReceiptList={bouncedReceiptList} invoiceAzure={invoiceAzure} />}
        <OrderList fullInfo={false} session={session} orderList={orderList} />
      </Stack>

      <Stack style={{ margin: "10px" }} display="flex" flexDirection="row" justifyContent="space-between">
        <ComplaintList fullInfo={false} session={session} complaintList={complaintList} generalDescList={generalDescList} />
        <NotificationList fullInfo={false} notificationList={notificationList} session={session} />
      </Stack>
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  session: state.session,
  invoiceList: state.invoiceList,
  bouncedReceiptList: state.bouncedReceiptList,
  invoiceAzure: state.invoiceAzure,
  complaintList: state.complaintList,
  orderList: state.orderList,
  prepaymentList: state.prepaymentList,
  preorder: state.preorderData,
  preorderList: state.preorderList,
  generalDescList: state.generalDescList,
  notificationList: state.notificationList
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(Dashboard);
